// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__e8Ttz","tab":"Tabs_tab__6Q7J-"};